// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"263af4fb","114":"e16708ca","296":"a60d4719","297":"05047072","327":"340f8f83","378":"dd7a8833","387":"372b55dd","453":"96bc5524","516":"72670dc8","970":"1f0dd666"}[chunkId] + ".chunk.js";
};